import React, { useState } from 'react';
import { Menu, MenuItem, Tab } from '@mui/material';
import { MoreVertOutlined, StarOutlined, StarOutlineOutlined, ArchiveOutlined, UnarchiveOutlined, SyncOutlined } from '@mui/icons-material';
import axios from "axios";
import { ConfirmMakePrimaryModal } from "~/components/patientReports/ConfirmMakePrimaryModal";
const PatientDevicesTab = ({ tabValue, deviceName, isPrimary, isArchived, onClick, selectedIndex, patient, handleMakePrimaryCallback, handleSyncCallback }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [isConfirmPrimaryOpen, setIsConfirmPrimaryOpen] = useState(false);
    var deviceNameSlug = '';
    switch (deviceName) {
        case '1':
            deviceNameSlug = 'Dexcom';
            break;
        case '2':
            deviceNameSlug = 'Libre';
            break;
        case '3':
            deviceNameSlug = 'Medtronic';
            break;
        case '4':
            deviceNameSlug = 'Tandem';
            break;
        case '5':
            deviceNameSlug = 'Glooko';
            break;
        case '6':
            deviceNameSlug = 'Eversense';
            break;
        case '7':
            deviceNameSlug = 'Beta Bionics';
            break;
        case '8':
            deviceNameSlug = 'Omnipod';
            break;
        case 'dexcom':
            deviceNameSlug = 'Dexcom';
            break;
        case 'libre':
            deviceNameSlug = 'Libre';
            break;
        case 'carelink':
            deviceNameSlug = 'Medtronic';
            break;
        case 'tandem':
            deviceNameSlug = 'Tandem';
            break;
        case 'omnipod':
            deviceNameSlug = 'Glooko';
            break;
        case 'eversense':
            deviceNameSlug = 'Eversense';
            break;
        case 'betabionics':
            deviceNameSlug = 'Beta Bionics';
            break;
        case 'omnipoddiscover':
            deviceNameSlug = 'Omnipod';
            break;
    }
    const handleClick = (event) => {
        console.log(event);
        setAnchorEl(event.currentTarget.parentElement);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleArchive = async () => {
        handleClose();
        const response = await axios.post('/api/patient/togglePatientArchive', {
            patient_id: patient.id
        });
        if (response.data.data.status) {
            alert('Patient archived');
            window.location.reload();
        }
    };
    const handleReactivate = async () => {
        handleClose();
        const response = await axios.post('/api/patient/togglePatientArchive', {
            patient_id: patient.id
        });
        if (response.data.data.status) {
            alert('Patient activated');
            window.location.reload();
        }
    };
    const handleMakePrimary = () => {
        console.log('making primary');
        console.log(anchorEl);
        handleClose();
        handleMakePrimaryCallback(patient);
    };
    const handleSync = () => {
        handleClose();
        handleSyncCallback(patient);
    };
    let textColor = '';
    let isSelectable = true;
    if (isArchived) {
        textColor = '#00000033';
        isSelectable = false;
    }
    else {
        textColor = '#00000099';
    }
    if (patient.lastReport.length === 0) {
        textColor = '#00000033';
        isSelectable = false;
    }
    return (React.createElement("div", { className: 'align-middle' },
        isPrimary && React.createElement(StarOutlined, { fontSize: 'small', color: 'primary' }),
        React.createElement(Tab, { id: deviceName, icon: React.createElement(MoreVertOutlined, { fontSize: 'small', onClick: (event) => handleClick(event) }), iconPosition: "end", label: deviceNameSlug, value: tabValue, className: "inline-block padding-text", key: deviceNameSlug, onClick: () => { if (isSelectable) {
                onClick(deviceNameSlug, tabValue);
            } }, sx: { fontWeight: 'bold', minHeight: '0px', height: '45px', opacity: '1', color: tabValue === selectedIndex ? '#2C78EB' : textColor } }),
        React.createElement(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                'aria-labelledby': 'basic-button',
            } },
            (!isArchived && !isPrimary) && React.createElement(MenuItem, { onClick: () => setIsConfirmPrimaryOpen(true) },
                React.createElement(StarOutlineOutlined, null),
                " Make Primary"),
            (!isArchived) && React.createElement(MenuItem, { onClick: handleSync },
                React.createElement(SyncOutlined, null),
                " Sync"),
            (!isArchived && !isPrimary) ? React.createElement(MenuItem, { onClick: handleArchive },
                React.createElement(ArchiveOutlined, null),
                " Archive") : React.createElement(React.Fragment, null),
            (isArchived && !isPrimary) ? React.createElement(MenuItem, { onClick: handleReactivate },
                React.createElement(UnarchiveOutlined, null),
                " Unarchive") : React.createElement(React.Fragment, null)),
        isConfirmPrimaryOpen && React.createElement(ConfirmMakePrimaryModal, { onRequestClose: () => setIsConfirmPrimaryOpen(false), onConfirm: handleMakePrimary, deviceName: deviceNameSlug })));
};
export default PatientDevicesTab;
